import BlcLayoutBase from 'components/BlcLayout/BlcLayout.base.js';
import BackgroundCircles from './BackgroundCircles';
import TopBarLogo from './TopBarLogo';
import { loggedUSerSelector } from 'store/slices/loggedUsers/selector';
import { getState } from 'store/store';

const PublicLayout = (props) => {
	const user = loggedUSerSelector(getState());
	return (
		<BlcLayoutBase {...props?.meta}>
			{!user?.id && !props.isLoginPage && <TopBarLogo navigateToLanding={props.isPublicPage} />}
			<BackgroundCircles authenticated={Boolean(user?.id)} isLoginPage={props.isLoginPage}>
				{props.children}
			</BackgroundCircles>
		</BlcLayoutBase>
	);
};

export default PublicLayout;
